import React, { memo } from "react";
import { List, PriceBadge, Badge, ListItem, ListControls } from "./styled";
import Tooltip from "_c/Tooltip";
import { CircleButton } from "_c/button";
import ModelSearchIcon from "_c/icon/Lady";
import CombScissorsIcon from "_c/icon/CombScissors";
import { mul } from "@/utils/money";
import DenyIcon from "_c/icon/Deny";
import GearIcon from "_c/icon/Gear";
import PT from "prop-types";
import Confirmable from "_c/Confirmable";

const DiscountsList = ({ t, ns, ...props }) => {
  return (
    <List>
      {props.discounts.map((disc) => {
        const isActive = props.activeDiscount?._id === disc._id;
        const onRemove = async () => {
          await props.deleteDiscount(disc._id);
          props.closeForm();
        };
        return (
          <ListItem
            hasActive={Boolean(props.activeDiscount)}
            isActive={isActive}
            key={disc._id}
          >
            <PriceBadge style={{ marginInlineEnd: "25px" }}>
              -{mul(disc.amount, 100)}%
            </PriceBadge>
            {disc.client && (
              <Tooltip title={t(`${ns}.types.client`)}>
                <Badge style={{ fontSize: "18px" }}>%</Badge>
              </Tooltip>
            )}
            {!disc.service && (
              <Tooltip title={t(`${ns}.types.all`)}>
                <Badge large light>
                  <CombScissorsIcon width="24" color="white" />
                </Badge>
              </Tooltip>
            )}
            {disc.model_search && (
              <Tooltip title={t(`${ns}.types.model`)}>
                <Badge large light>
                  <ModelSearchIcon width="24" color="white" />
                </Badge>
              </Tooltip>
            )}
            <ListControls>
              <CircleButton
                title={t(`common:${isActive ? "close" : "open"}`)}
                onClick={() =>
                  isActive ? props.closeForm() : props.openForm(disc)
                }
                medium
                primary
              >
                <GearIcon width="20" color="white" />
              </CircleButton>
              <Confirmable
                title={t(`${ns}.remove_confirm`)}
                acceptText={t("common:remove")}
                rejectText={t("common:cancel")}
                onAccept={onRemove}
              >
                <CircleButton
                  title={t("common:remove")}
                  style={{ marginInlineStart: "7px" }}
                  medium
                  negative
                >
                  <DenyIcon color="white" />
                </CircleButton>
              </Confirmable>
            </ListControls>
          </ListItem>
        );
      })}
    </List>
  );
};
DiscountsList.displayName = "DiscountsList";
DiscountsList.propTypes = {
  discounts: PT.array.isRequired,
  activeDiscount: PT.object,

  t: PT.func.isRequired,
  deleteDiscount: PT.func.isRequired,
  openForm: PT.func.isRequired,
  closeForm: PT.func.isRequired,
};

export default memo(DiscountsList);
